import { createSlice } from '@reduxjs/toolkit';
import { getToday } from '../../components/Calendar/util';

const initialState = {
	debts: [],
	selectedDate: getToday(),
	StatepaidOnNextPeriodsDelay: [],
	stateDelaypastMonth: [],
	stateIndexDelayMonth: null,
};

const debtsSlice = createSlice({
	name: 'debts',
	initialState,
	reducers: {
		setSelectedDates(state, action) {
			state.selectedDate = action.payload;
		},
		setPaidOnNextPeriodsDelay(state, action) {
			state.StatepaidOnNextPeriodsDelay = action.payload;
		},
		setDelayPastMonth(state, action) {
			state.stateDelaypastMonth = action.payload;
		},
		setIndexDelayMonth(state, action) {
			state.stateIndexDelayMonth = action.payload;
		},
	},
});

export const { setSelectedDates, setPaidOnNextPeriodsDelay, setDelayPastMonth, setIndexDelayMonth } =
	debtsSlice.actions;
export default debtsSlice.reducer;
